import React, { useEffect, useState } from "react";
import axios from 'axios';

import SurahListComponent from "../../components/SurahList/SurahListComponent";

export default function QuoranList() {
    const [surahList,setSurahList] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    useEffect(()=> {
      setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/surah`).then((res) => {
            setSurahList(res.data);
            setIsLoading(false);
        }).catch((err) => {
            console.log(err);
            setIsLoading(false);
        });
    },[]);

  return (
    <SurahListComponent sectionClass="pt-5 bg-light" surahList={surahList} isLoading={isLoading} sectionTitle="Quran Transliteration" sectionDesc="Quran Transliteration simplifies the pronunciation of Arabic text for non-native speakers, facilitating easier recitation and understanding of the Quran." />
  )
}
